<div class="card">
  <div class="d-flex">
    <a class="mb-0 h2" [routerLink]="['/workflows']">{{ configuration.title }}</a>
    <a [routerLink]="['/workflows']" class="ms-auto" translate>view_all</a>
  </div>
  @if (configuration.description) {
    <h6 class="card-subtitle mb-2 mt-2 text-muted">{{ configuration.description }}</h6>
  }
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  @if (!isLoading) {
    <div class="d-flex flex-column">
      <div class="table-responsive">
        <table style="max-height: 500px">
          <thead>
            <tr>
              <th scope="col" translate>workflow.name</th>
              <th scope="col" translate>workflow.description</th>
            </tr>
          </thead>
          <tbody>
            @for (item of workflows; track item.id) {
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.description }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
